import React from 'react';
import { Helmet } from 'react-helmet';
import defaultImage from '~/images/ogp.jpg';

const defaultDescription =
  'SNS時代に”共感”と”購買”を生み出すデジタルエージェンシー';

type Props = {
  readonly title?: string;
  readonly description?: string;
  readonly image?: string;
};

export const SEO: React.FC<Props> = ({ title, description, image }) => {
  const seo = {
    title: title ? title + ' | RE ROOTS' : 'RE ROOTS',
    description: description ?? defaultDescription,
    image: image ?? defaultImage,
    url: 'https://reroots.co.jp',
  };

  return (
    <Helmet>
      <title>{seo.title}</title>
      <html lang="ja" />
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta name="og:title" content={seo.title} />
      <meta name="og:site_name" content={seo.title} />
      <meta name="og:type" content="website" />
      <meta name="og:description" content={seo.description} />
      <meta name="og:url" content={seo.url} />
      <meta name="og:image" content={seo.image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
    </Helmet>
  );
};
